import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading } from '../../components';

import css from './ListingPage.module.css';

const SectionDetailsMaybe = props => {
  const { publicData, metadata = {}, listingConfig, intl } = props;
  const { listingFields } = listingConfig || {};

  if (!publicData || !listingConfig) {
    return null;
  }

  const isValidDetail = value => value != null && value !== '' && String(value) !== 'NaN';


  const pickListingFields = (filteredConfigs, config) => {
    const { key, schemaType, enumOptions, includeForListingTypes, showConfig = {} } = config;
    const listingType = publicData.listingType;
    const isTargetListingType =
      includeForListingTypes == null || includeForListingTypes.includes(listingType);

    const { isDetail, label } = showConfig;
    const publicDataValue = publicData[key];
    const metadataValue = metadata[key];
    const value = publicDataValue || metadataValue;

    if (isDetail && isTargetListingType && typeof value !== 'undefined') {
      const findSelectedOption = enumValue => enumOptions?.find(o => enumValue === `${o.option}`);
      const getBooleanMessage = value =>
        value
          ? intl.formatMessage({ id: 'SearchPage.detailYes' })
          : intl.formatMessage({ id: 'SearchPage.detailNo' });
      const optionConfig = findSelectedOption(value);

      return schemaType === 'enum'
        ? filteredConfigs.concat({ key, value: optionConfig?.label, label })
        : schemaType === 'boolean'
        ? filteredConfigs.concat({ key, value: getBooleanMessage(value), label })
        : schemaType === 'long'
        ? filteredConfigs.concat({ key, value, label })
        : filteredConfigs;
    }
    return filteredConfigs;
  };
  const { sizeM, sizeSqft, roomsInHotel, numberOfBathrooms, numberOfBedrooms } = publicData || {};
  const isOtherFields = !!(
    sizeM ||
    sizeSqft ||
    roomsInHotel ||
    numberOfBathrooms ||
    numberOfBedrooms
  );
  // console.log('isOtherFields', isOtherFields);
  const existingListingFields = listingFields.reduce(pickListingFields, []);
  return existingListingFields.length > 0 || isOtherFields ? (
    <div className={css.sectionDetails}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        <FormattedMessage id="ListingPage.detailsTitle" />
      </Heading>
      <ul className={css.details}>
        {existingListingFields?.map(detail => {
          if (!isValidDetail(detail.value)) return null;
          return (
            <li key={detail.key} className={css.detailsRow}>
              <span className={css.detailLabel}>{detail.label}</span>
              <span>{detail.value}</span>
            </li>
          );
        })}
        {isValidDetail(sizeM) ? (
          <li className={css.detailsRow}>
            <span className={css.detailLabel}>
              <FormattedMessage id="ListingPage.sizeM" />
            </span>
            <span>{sizeM}</span>
          </li>
        ) : null}
        {isValidDetail(sizeSqft) ? (
          <li className={css.detailsRow}>
            <span className={css.detailLabel}>
              <FormattedMessage id="ListingPage.sizeSqft" />
            </span>
            <span>{sizeSqft}</span>
          </li>
        ) : null}
        {isValidDetail(roomsInHotel) ? (
          <li className={css.detailsRow}>
            <span className={css.detailLabel}>
              <FormattedMessage id="ListingPage.roomsInHotel" />
            </span>
            <span>{roomsInHotel}</span>
          </li>
        ) : null}
        {isValidDetail(numberOfBathrooms) ? (
          <li className={css.detailsRow}>
            <span className={css.detailLabel}>
              <FormattedMessage id="ListingPage.numberOfBathrooms" />
            </span>
            <span>{numberOfBathrooms}</span>
          </li>
        ) : null}
        {isValidDetail(numberOfBedrooms) ? (
          <li className={css.detailsRow}>
            <span className={css.detailLabel}>
              <FormattedMessage id="ListingPage.numberOfBedrooms" />
            </span>
            <span>{numberOfBedrooms}</span>
          </li>
        ) : null}
      </ul>
    </div>
  ) : null;
};

export default SectionDetailsMaybe;
